import React, { Component } from 'react';
import {
    Form, Input, Button, Select, Modal, InputNumber,
} from 'antd';

import 'antd/dist/antd.css';

const Option = Select.Option;
let show = {
    display: 'none',
};

function handleChange(value) {
    console.log(`selected ${value}`);
    if (value === 'Otro') {
        show = {
            display: 'block',
        };
    } else {
        show = {
            display: 'none',
        };
    }
}

function handleBlur() {
    console.log('blur');
}

function handleFocus() {
    console.log('focus');
}

class MachineLogAddView extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        // console.log(e);
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.handleSubmit(values);
                this.props.form.resetFields();
            }
        });
    }

    render() {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };
        const { getFieldDecorator } = this.props.form;
        const { log } = this.props;
        return (
            <div>
                <Modal
                    title="Logs Administration"
                    visible={this.props.openForm}
                    onOk={this.handleOk}
                    onCancel={this.props.onCancel}
                    footer={null}
                >
                    <Form onSubmit={this.handleSubmit}>
                        <Form.Item
                            {...formItemLayout}
                            label="Type"
                        >
                            {getFieldDecorator('type', {
                                initialValue: (log != null) ? log.type : '',
                                rules: [{ required: true, message: 'Select a Type' }],
                            })(
                                <Select
                                    showSearch
                                    style={{ width: 200 }}
                                    placeholder="Select a Type"
                                    optionFilterProp="children"
                                    onChange={handleChange}
                                    onFocus={handleFocus}
                                    onBlur={handleBlur}
                                    filterOption={(input, option) => option.props.children.toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0}
                                >
                                    <Option value="Check">
                                        Check
                                    </Option>
                                    <Option value="Repair">
                                        Repair
                                    </Option>
                                    <Option value="Information">
                                        Information
                                    </Option>
                                    <Option value="Maintenance">
                                        Maintenance
                                    </Option>
                                    <Option value="Other">
                                        Other
                                    </Option>
                                </Select>,
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="Other"
                            style={show}
                        >
                            {getFieldDecorator('other', {
                                initialValue: (log != null) ? log.other : '',
                            })(
                                <Input />,
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="Cost"
                        >
                            {getFieldDecorator('cost', {
                                initialValue: (log != null) ? log.cost : '',
                                rules: [{ required: true, message: 'Insert Cost' }],
                            })(
                                <InputNumber min={0} />,
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="Description"
                        >
                            {getFieldDecorator('description', {
                                initialValue: (log != null) ? log.description : '',
                                rules: [{ required: true, message: 'Insert description' }],
                            })(
                                <Input.TextArea rows={4} />,
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="Location"
                        >
                            {getFieldDecorator('location', {
                                initialValue: (log != null) ? log.location : '',
                                rules: [{ required: true, message: 'Insert Location' }],
                            })(
                                <Input />,
                            )}
                        </Form.Item>
                        <Form.Item {...tailFormItemLayout}>
                            <Button type="primary" htmlType="submit" onClick={this.handleOk}>
                                Save
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        );
    }
}

export default Form.create()(MachineLogAddView);



// WEBPACK FOOTER //
// ./src/components/views/MachineLogAddView.js